import { useIdentify } from '@hungryroot/rest-hooks';
import { useCustomerPairingRatings } from './useCustomerPairingRatings';

/** Get the rating for a recipe by id, for the signed in user, or undefined if no logged in user or no rating exists */
export const useCustomerRecipeRatingById = (recipeId?: number) => {
  const { customerData } = useIdentify();

  // If we don't have customer data we won't use the response from this hook
  const ratings = useCustomerPairingRatings(customerData?.id ?? 0);

  if (!customerData || !recipeId) {
    return undefined;
  }

  const rating = ratings?.data?.[recipeId];
  if (rating === undefined || rating === null) {
    // If the user has not specified a rating, return undefined
    return undefined;
  }
  return rating;
};
